module.exports = __webpack_public_path__ + "static/rewards-card-lancer-scorpion-0f1b3827b77fec0b3cbc4da6a34329ef.png";